import React from "react";

export const FileUploadLogo = ({
  width = "24",
  height = "24",
  fill = "none",
  color = "white",
}) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33301 10.0003V12.1205C3.33301 14.8247 3.33301 16.1767 4.0714 17.0926C4.22057 17.2776 4.3891 17.4461 4.57412 17.5952C5.48993 18.3337 6.84202 18.3337 9.54617 18.3337C10.1342 18.3337 10.4281 18.3337 10.6973 18.2387C10.7533 18.2189 10.8082 18.1962 10.8618 18.1706C11.1193 18.0473 11.3272 17.8395 11.7429 17.4237L15.69 13.4767C16.1718 12.9949 16.4126 12.7541 16.5395 12.4477C16.6663 12.1415 16.6663 11.8008 16.6663 11.1196V8.33366C16.6663 5.19096 16.6663 3.61962 15.69 2.6433C14.7138 1.66699 13.1423 1.66699 9.99967 1.66699M10.833 17.917V17.5003C10.833 15.1433 10.833 13.9648 11.5653 13.2326C12.2975 12.5003 13.476 12.5003 15.833 12.5003H16.2497"
      stroke={color}
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33301 4.16699C7.84147 3.66129 6.53323 1.66699 5.83301 1.66699C5.13278 1.66699 3.82454 3.66129 3.33301 4.16699M5.83301 2.50033V8.33366"
      stroke={color}
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
